import { SensorGroupSensor } from '../models/sensorGroupSensor'

export interface SensorGroupSensorStateType {
  sensorGroupSensors: SensorGroupSensor[]
  sensorGroupSensor: SensorGroupSensor | null
}

const SensorGroupSensorState: () => SensorGroupSensorStateType = () => ({
  sensorGroupSensors: [],
  sensorGroupSensor: null,
})

export default SensorGroupSensorState
